// extracted by mini-css-extract-plugin
module.exports = {"item":"cartitem-module--item--2lgAX","buttonUpdate":"cartitem-module--button-update--GsPzY","buttonDelete":"cartitem-module--button-delete--2ed5E"};